import { AllowedLocales, I18NConfig } from "@/lib/types";

export const defaultLocale = "it";

export const allowedLocales: AllowedLocales = [defaultLocale, "en", "scn"];

const i18nConfig: I18NConfig = {
  locales: allowedLocales,
  defaultLocale,
  prefixDefault: false, // avoids prefixing the default locale in URLs
};

export { i18nConfig };